import React from "react";
import { Globe } from "lucide-react";
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';

const Footer = () => {
  return (
    <footer className="text-white" style={{ backgroundColor: 'rgb(0, 0, 0)' }}>
      {/* Top separator line */}
      <div className="h-px bg-white"></div>
      
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Main Footer Content */}
        <div className="flex flex-col md:flex-row justify-between items-start space-y-6 md:space-y-0">
          
          {/* Left side - Navigation Links */}
          <div className="flex flex-col space-y-4">
            {/* First row */}
            <div className="flex flex-wrap space-x-6">
                             <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 700, color: 'rgb(255, 255, 255)' }}>
                 Careers
               </a>
               <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 700, color: 'rgb(255, 255, 255)' }}>
                 The Ritz-Carlton Club
               </a>
               <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 700, color: 'rgb(255, 255, 255)' }}>
                 Shops
               </a>
               <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 700, color: 'rgb(255, 255, 255)' }}>
                 The Ritz-Carlton Leadership Center
               </a>
            </div>
            
            {/* Second row */}
                         <div className="flex flex-wrap space-x-6">
               <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 700, color: 'rgb(255, 255, 255)' }}>
                 Marriott Bonvoy
               </a>
               <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 700, color: 'rgb(255, 255, 255)' }}>
                 Contact
               </a>
               <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 700, color: 'rgb(255, 255, 255)' }}>
                 Media Contact
               </a>
               <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 700, color: 'rgb(255, 255, 255)' }}>
                 Privacy Center
               </a>
             </div>
            
            {/* Third row */}
                         <div className="flex flex-wrap items-center space-x-6">
               <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 700, color: 'rgb(255, 255, 255)' }}>
                 Tracking Preferences
               </a>
               <div className="flex items-center space-x-2">
                 <div className="w-4 h-4 border border-gray-400 rounded flex items-center justify-center">
                   <span className="text-xs">✓</span>
                 </div>
                 <span className="text-xs text-gray-400">×</span>
               </div>
               <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 700, color: 'rgb(255, 255, 255)' }}>
                 Your Privacy Choices
               </a>
             </div>
          </div>

          {/* Right side - Social Media and Language */}
          <div className="flex flex-col items-end space-y-4">
            {/* Social Media Icons */}
                         <div className="flex space-x-8">
               <FacebookOutlinedIcon style={{ color: 'white', fontSize: '20px' }} />
               <i className="fa-brands fa-instagram" style={{ color: 'white', fontSize: '20px' }}></i>
               <span className="text-white text-xl font-bold">𝕏</span>
               <i className="fa-brands fa-linkedin" style={{ color: 'white', fontSize: '20px' }}></i>
               <i className="fa-brands fa-youtube" style={{ color: 'white', fontSize: '20px' }}></i>
             </div>
            
            {/* Language Selector */}
                         <div className="flex items-center space-x-2">
               <Globe className="w-4 h-4 text-gray-300" />
               <span className="text-gray-300" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 700, color: 'rgb(255, 255, 255)' }}>English</span>
             </div>
          </div>
        </div>

        {/* Bottom Section - 3 Column Grid */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            
            {/* Column 1 - Logo */}
            <div className="flex flex-col items-center md:items-start">
              <img 
                src="/images/Ritz-Carlton-Logo.jpg"
                alt="The Ritz-Carlton"
                style={{ width: '267.465px', height: '108px' }}
                className="object-contain"
              />
            </div>

            {/* Column 2 - RITZ Trademark Description */}
            <div className="flex flex-col items-center md:items-center">
              <p className="max-w-md" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 500, textAlign: 'center', color: 'rgb(255, 255, 255)' }}>
                RITZ® is a Registered Service Mark of The Ritz Hotel, Limited, and is used by The Ritz-Carlton Hotel Company under License.
              </p>
              <p className="mt-2" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 500, textAlign: 'center', color: 'rgb(255, 255, 255)' }}>
                © 2025 The Ritz-Carlton Hotel Company, L.L.C. All rights reserved.
              </p>
            </div>

            {/* Column 3 - Terms of Use */}
            <div className="flex flex-col items-center md:items-end space-y-2">
              <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 700, color: 'rgb(255, 255, 255)' }}>
                Terms of Use
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 700, color: 'rgb(255, 255, 255)' }}>
                BEIAN CN Site
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" style={{ fontFamily: 'Swiss-721, Arial, sans-serif', fontSize: '16px', fontWeight: 700, color: 'rgb(255, 255, 255)' }}>
                Do Not Sell Information
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;